<div class="container-fluid lh-container-fluid" itemscope itemtype="http://schema.org/LocalBusiness">
  <div class="flex">
    <div class="content">
      <h4>LuggageHero Terms of Service</h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor varius imperdiet. Ut pretium id enim in
        lacinia. Donec eu blandit diam, a ultricies risus. Sed at tempor ante, vitae efficitur nisi. Curabitur congue eu
        velit sed dapibus. Nunc pharetra accumsan nibh at sodales. Quisque dapibus imperdiet faucibus.
      </p>
      <h6>General</h6>
      <p>
        Donec faucibus massa non odio elementum euismod. Integer velit dui, rhoncus vel faucibus quis, cursus sed nunc.
        Nunc elementum molestie purus, sed vulputate ante bibendum a. Cras consectetur pulvinar erat ut luctus. Aenean
        facilisis justo tortor, quis pharetra risus placerat in. Etiam posuere, velit sit amet eleifend venenatis, nunc
        justo maximus nunc, ut molestie diam augue sed erat. Aenean non neque venenatis, congue nunc pulvinar, egestas
        libero. Vestibulum fermentum nibh efficitur lectus auctor, ac volutpat diam placerat. Etiam pharetra bibendum
        lorem in tristique. Mauris lacinia aliquam sapien vel pulvinar. Sed nibh nulla, porta id magna eu, tincidunt
        vulputate nunc.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor varius imperdiet. Ut pretium id enim in
        lacinia. Donec eu blandit diam, a ultricies risus. Sed at tempor ante, vitae efficitur nisi. Curabitur congue eu
        velit sed dapibus. Nunc pharetra accumsan nibh at sodales. Quisque dapibus imperdiet faucibus.
      </p>
      <h6>Liability</h6>
      <p>
        Nulla facilisi. Morbi porta sodales elit vel interdum. Aenean lacinia tempus ipsum non vestibulum. Sed libero
        quam, molestie vitae tellus feugiat, molestie ullamcorper sem. Etiam eget risus elit. Morbi porttitor, libero
        eget consequat bibendum, elit augue consectetur risus, ut bibendum diam odio a nisi. Cras id cursus quam.
        Vivamus facilisis aliquam hendrerit. Pellentesque auctor facilisis metus eu maximus. Nam tincidunt ligula
        mauris, pretium egestas quam dictum sit amet. Nunc volutpat laoreet enim, et venenatis ipsum egestas sit amet.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor varius imperdiet. Ut pretium id enim in
        lacinia. Donec eu blandit diam, a ultricies risus. Sed at tempor ante, vitae efficitur nisi. Curabitur congue eu
        velit sed dapibus. Nunc pharetra accumsan nibh at sodales. Quisque dapibus imperdiet faucibus.
      </p>
      <p>
        Nulla facilisi. Morbi porta sodales elit vel interdum. Aenean lacinia tempus ipsum non vestibulum. Sed libero
        quam, molestie vitae tellus feugiat, molestie ullamcorper sem. Etiam eget risus elit. Morbi porttitor, libero
        eget consequat bibendum, elit augue consectetur risus, ut bibendum diam odio a nisi. Cras id cursus quam.
        Vivamus facilisis aliquam hendrerit. Pellentesque auctor facilisis metus eu maximus. Nam tincidunt ligula
        mauris, pretium egestas quam dictum sit amet. Nunc volutpat laoreet enim, et venenatis ipsum egestas sit amet.
      </p>
      <h6>Process</h6>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor varius imperdiet. Ut pretium id enim in
        lacinia. Donec eu blandit diam, a ultricies risus. Sed at tempor ante, vitae efficitur nisi. Curabitur congue eu
        velit sed dapibus. Nunc pharetra accumsan nibh at sodales. Quisque dapibus imperdiet faucibus.
      </p>
      <p>
        Donec faucibus massa non odio elementum euismod. Integer velit dui, rhoncus vel faucibus quis, cursus sed nunc.
        Nunc elementum molestie purus, sed vulputate ante bibendum a. Cras consectetur pulvinar erat ut luctus. Aenean
        facilisis justo tortor, quis pharetra risus placerat in. Etiam posuere, velit sit amet eleifend venenatis, nunc
        justo maximus nunc, ut molestie diam augue sed erat. Aenean non neque venenatis, congue nunc pulvinar, egestas
        libero. Vestibulum fermentum nibh efficitur lectus auctor, ac volutpat diam placerat. Etiam pharetra bibendum
        lorem in tristique. Mauris lacinia aliquam sapien vel pulvinar. Sed nibh nulla, porta id magna eu, tincidunt
        vulputate nunc.
      </p>
      <h6>Termination</h6>
      <p>
        Nulla facilisi. Morbi porta sodales elit vel interdum. Aenean lacinia tempus ipsum non vestibulum. Sed libero
        quam, molestie vitae tellus feugiat, molestie ullamcorper sem. Etiam eget risus elit. Morbi porttitor, libero
        eget consequat bibendum, elit augue consectetur risus, ut bibendum diam odio a nisi. Cras id cursus quam.
        Vivamus facilisis aliquam hendrerit. Pellentesque auctor facilisis metus eu maximus. Nam tincidunt ligula
        mauris, pretium egestas quam dictum sit amet. Nunc volutpat laoreet enim, et venenatis ipsum egestas sit amet.
      </p>
    </div>
    <div class="footer">
      <lh-progress-bar
        *ngIf="isProgressBarRequired"
        [currentValue]="documentPosition"
        [maxValue]="documentHeight"
        [compact]="true"
      ></lh-progress-bar>
      <div class="footer-actions">
        <!-- Small screen buttons -->
        <div class="d-block d-sm-none">
          <button
            class="btn btn-block btn-primary"
            (click)="startTosAcceptance()"
            [disabled]="isLoading || !isTermsOfServiceReviewed"
          >
            <span *ngIf="!isLoading">{{ 'ACCEPT_TERMS_OF_SERVICE_CONFIRMATION' | translate }}</span>
            <span *ngIf="isLoading">{{ 'PLEASE_WAIT' | translate }}</span>
          </button>
          <button class="btn btn-block btn-link" routerLink="/dashboard" [disabled]="isLoading">
            {{ 'CANCEL' | translate }}
          </button>
        </div>
        <!-- Large screen buttons -->
        <div class="d-none d-sm-block">
          <button class="btn btn-lg btn-link" routerLink="/dashboard" [disabled]="isLoading">
            {{ 'CANCEL' | translate }}
          </button>
          <div class="flex pull-right">
            <lh-shared-ui-spinner [visible]="isLoading"></lh-shared-ui-spinner>
            <button
              class="btn btn-lg btn-primary"
              (click)="startTosAcceptance()"
              [disabled]="isLoading || !isTermsOfServiceReviewed"
            >
              <span>{{ 'ACCEPT_TERMS_OF_SERVICE_CONFIRMATION' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="message">
        <div class="text-danger" *ngIf="!isTermsOfServiceReviewed">
          <small>You must review the terms before you can accept</small>
        </div>
        <div class="text-success" *ngIf="isTermsOfServiceReviewed">
          <small>Hit the accept button to proceed</small>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Terms of Service acceptance modal -->
<div
  class="modal fade"
  bsModal
  #tosAcceptanceModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ 'CONFIRM_ACCEPTANCE' | translate }}</h4>
        <button
          id="closeReviewsModal"
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="tosAcceptanceModal.hide()"
        >
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="!storageManagerPhoneNumber">
          <p>{{ 'WILL_SEND_OTP_TO_ACCEPT_TOS' | translate }}.</p>
          <p>{{ 'PROVIDE_MOBILE_PHONE_NO_TO_CONTINUE' | translate }}.</p>
          <form [formGroup]="phoneNumberForm">
            <div class="form-group">
              <lh-phone-input
                id="phone"
                formControlName="phone"
                [advancedMode]="true"
                [(ngModel)]="phoneNumber"
                [placeholder]="'PHONE_NUMBER' | translate"
                [(selectedCountry)]="phoneCountry"
                [requestFocus]="false"
              >
              </lh-phone-input>
              <div *ngIf="isPhoneNumberFormSubmitted && phoneInputError" class="alert alert-danger">
                {{ phoneInputError | translate }}
              </div>
            </div>
          </form>

          <div class="form-group text-end">
            <button
              class="btn btn-block btn-primary mt-2"
              (click)="savePhoneNumber()"
              [disabled]="isLoading || (phoneInputError && isPhoneNumberFormSubmitted)"
            >
              <span *ngIf="!isLoading">{{ 'SEND_CODE' | translate }}</span>
              <span *ngIf="isLoading">{{ 'PLEASE_WAIT' | translate }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="storageManagerPhoneNumber">
          <p>{{ 'OTP_SENT_TO_PHONE_NO_ENDING_IN' | translate }} {{ storageManagerPhoneNumberLast4 }}.</p>
          <p>{{ 'ENTER_CODE_TO_CONFIRM_ACCEPTANCE' | translate }}.</p>
          <p>
            <code-input
              [isCodeHidden]="false"
              [isNonDigitsCode]="false"
              [codeLength]="4"
              (codeCompleted)="onCodeCompleted($event)"
            >
            </code-input>
          </p>
          <p class="text-center">
            {{ 'DID_NOT_RECEIVE_A_CODE' | translate }}
            <a class="href" (click)="resendConfirmationCode()">{{ 'RESEND' | translate }}</a>
          </p>

          <div class="validation-spinner">
            <lh-shared-ui-spinner [visible]="isLoading"></lh-shared-ui-spinner>
            <!-- TODO: Make this a dynamic status message that supports both error and success -->
            <div *ngIf="!isLoading && isConfirmationCodeSent" class="text-success">New code sent!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
